export default __webpack_public_path__ + "static/board-template3-35bd2ae9e9893199b7e9014556ae2526.png";